import { useEffect, useState } from 'react';
import type { ComponentProps } from 'react';
import { MultiSelectDropdown } from '@zawarski/eti-ui';

type DialogMultiSelectProps = Omit<ComponentProps<typeof MultiSelectDropdown>, 'container'>;

const createLayer = () => {
  if (typeof document === 'undefined') return null;
  const layer = document.createElement('div');
  // Styled in src/index.css: above the dialog, and held to the space under the picker.
  layer.dataset.repDialogSelectLayer = '';
  return layer;
};

/**
 * eti-ui's MultiSelectDropdown for use inside a DialogMod.
 *
 * Its list floats on <body> (src/index.css lifts every eti-ui popover over dialogs). Its inline
 * mode (`container={null}`) would be cut off instead: DialogMod clips its content.
 *
 * The list floats in its own layer on <body>, an empty stacking context that covers nothing
 * until the list opens. eti-ui opens the list downward only, so the layer's CSS fits it to the
 * space under the picker, the options list keeping the one scroll bar; a dialog sits mid-screen,
 * so its pickers are the ones that run out of room.
 */
const DialogMultiSelect = (props: DialogMultiSelectProps) => {
  const [layer] = useState(createLayer);
  useEffect(() => {
    if (!layer) return;
    document.body.appendChild(layer);
    return () => layer.remove();
  }, [layer]);
  return <MultiSelectDropdown {...props} container={layer ?? undefined} />;
};

export default DialogMultiSelect;
